// ---------------------------------------------------------------------------
// shared/constants/push-message-types.ts
//
// The `data.type` values carried by call push notifications.
//
// Why this file exists: the server sent `'incoming_call'` and the service
// worker checked for `'call:incoming'`. Neither side was wrong on its own
// terms and both were internally consistent, so nothing failed loudly — the
// push arrived, the service worker's `if (data.type !== ...) return;` dropped
// it, and no notification ever appeared. Push has never worked, and there was
// nothing in any log to say so.
//
// The string is a wire contract between three separate runtimes (Node sender,
// browser service worker, React adapter), which is exactly the situation a
// shared constant exists for. `push-contract.test.ts` asserts every one of
// them uses these values.
//
// The service worker is plain JS loaded by the browser and cannot import from
// here, so it declares its own copy — the test pins them together.
// ---------------------------------------------------------------------------

/** A call is ringing this device's owner right now. */
export const PUSH_TYPE_INCOMING_CALL = 'call:incoming';

/** A call rang and nobody answered it. */
export const PUSH_TYPE_MISSED_CALL = 'call:missed';

/** Every type the call push surface uses. */
export const CALL_PUSH_TYPES = [
  PUSH_TYPE_INCOMING_CALL,
  PUSH_TYPE_MISSED_CALL,
] as const;

export type CallPushType = (typeof CALL_PUSH_TYPES)[number];
